import { memo } from "react"

interface CheckProps {
  notSoon?: boolean
}

export const Check: React.FC<CheckProps> = memo((props: CheckProps) => {
  return (
    <div className="flex items-center space-x-3">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        className="h-6 w-6 text-green-500"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      {!props.notSoon && (
        <span className="ml-1 rounded-lg bg-zinc-800 px-1.5 py-0.5 text-xs text-zinc-400">
          Soon
        </span>
      )}
    </div>
  )
})

Check.displayName = "Check"
